import { Capacitor } from '@capacitor/core'

// Quais recomendações a tela atual pode mostrar (Story-6066). Compartilhado
// entre o menu lateral (ComposedHeader) e o carrossel da aula (StudentClass)
// para que os dois apliquem exatamente as mesmas regras de ocultação.
export default {
  computed: {
    // Mesmo id da rota: /p/course/:id e /p/course/:enrollId/class/:id
    recommendationEnrollId () {
      const route = this.$route
      if (!route) return null
      if (route.name === 'class') return route.params.enrollId || null
      if (route.name === 'course') return route.params.id || null
      return null
    },
    // Offline, preview do produtor ou aula baixada: o bloco não aparece.
    recommendationsBlocked () {
      if (!this.recommendationEnrollId) return true
      if (this.$store.state.enroll.isPreview) return true

      if (Capacitor.isNativePlatform()) {
        if (!this.$store.getters['dom/isConnected']) return true
        if (this.$route.name === 'class') {
          const status = this.$store.getters['download/getLearningObjectStatus'](
            this.recommendationEnrollId,
            this.$route.params.id
          )
          if (status === 'downloaded') return true
        }
      }
      return false
    },
    recommendations () {
      if (this.recommendationsBlocked) return []
      return this.$store.getters['recommendation/itemsFor'](this.recommendationEnrollId)
    }
  }
}
